import { Box, IconButton, Stack, StackProps, SvgIcon } from '@mui/material'

export type EmblaControlsProps = StackProps &
  Partial<{
    navigation: boolean
    scrollSnaps: number[]
    selectedIndex: number
    prevBtnDisabled: boolean
    nextBtnDisabled: boolean
    // eslint-disable-next-line no-unused-vars
    onDotClick: (index: number) => void
    scrollPrev: () => void
    scrollNext: () => void
  }>

const EmblaControls = ({
  navigation = true,
  scrollSnaps = [],
  selectedIndex = 0,
  prevBtnDisabled,
  nextBtnDisabled,
  scrollPrev,
  scrollNext,
  onDotClick,
  ...props
}: EmblaControlsProps) => {
  return (
    <Stack direction="row" spacing={4} alignItems="center" {...props}>
      {navigation ? (
        <Box>
          <Stack direction="row" spacing={2} alignItems="center">
            <IconButton
              size="medium"
              onClick={scrollPrev}
              disabled={prevBtnDisabled}
              color="secondary"
            >
              <SvgIcon fontSize="medium">
                <use href="#ico-arrow-prev" />
              </SvgIcon>
            </IconButton>
            <IconButton
              size="medium"
              onClick={scrollNext}
              disabled={nextBtnDisabled}
              color="secondary"
            >
              <SvgIcon fontSize="medium">
                <use href="#ico-arrow-next" />
              </SvgIcon>
            </IconButton>
          </Stack>
        </Box>
      ) : null}

      <Box sx={{ display: 'flex', gap: 1 }}>
        {scrollSnaps.map((_, index) => (
          <Box
            key={index}
            component="button"
            onClick={() => onDotClick?.(index)}
            sx={(theme) => ({
              width: selectedIndex === index ? '32px' : '8px',
              p: 0,
              m: 0,
              height: '8px',
              borderRadius: selectedIndex === index ? theme.shape.borderRadius360 : '50%',
              border: 'none',
              backgroundColor:
                selectedIndex === index ? theme.palette.primary.main : theme.customColors.blue[50],
              cursor: 'pointer',
              transition: `all 0.3s ${theme.customEasings.outCubic}`
            })}
          />
        ))}
      </Box>
    </Stack>
  )
}

export default EmblaControls
